import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_PROVINCE,
    fetchProvinceSuccessful,
    FETCH_DISTRICTS,
    fetchDistrictsSuccessful,
    FETCH_SECTORS,
    FETCH_CELLS,
    FETCH_VILLAGES,
    fetchSectorsSuccessful,
    fetchCellsSuccessful,
    fetchVillagesSuccessful

} from '../actions'



function * fetchLocations (paylaod){
    try{
       const response=  yield call(DCore.get, '/locations/types/province',{},{}, true)
        yield put (fetchProvinceSuccessful(response.data))

    }catch(e){
        console.log(e)
    }
}

function * fetchDistricts (payload){
    try{
        const response = yield call(DCore.get, `/locations/parent/${payload.data}`,true)
        yield put (fetchDistrictsSuccessful(response.data))
    }
    catch(e){
        console.log(e)
    }
}

function * fetchSectors (payload){
    try{
        const response = yield call(DCore.get, `/locations/parent/${payload.data}`,true)
        yield put (fetchSectorsSuccessful(response.data))
    }
    catch(e){
        console.log(e)
    }
}

function * fetchCells (payload){
    try{
        const response = yield call(DCore.get, `/locations/parent/${payload.data}`,true)
        yield put (fetchCellsSuccessful(response.data))
    }
    catch(e){
        console.log(e)
    }
}

function * fetchVillages (payload){
    try{
        const response = yield call(DCore.get, `/locations/parent/${payload.data}`,true)
        yield put (fetchVillagesSuccessful(response.data))
    }
    catch(e){
        console.log(e)
    }
}



export function * locationsSaga(){
    yield takeLatest(FETCH_PROVINCE,fetchLocations)
    yield takeLatest(FETCH_DISTRICTS, fetchDistricts)
    yield takeLatest(FETCH_SECTORS, fetchSectors)
    yield takeLatest(FETCH_CELLS, fetchCells)
    yield takeLatest(FETCH_VILLAGES, fetchVillages)



}